import React, { useMemo } from 'react';

import Tooltip from '@mui/material/Tooltip';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

// models
import { LinkElement } from '../../../models/editor.model';
import { EmailLinkInfo } from '../../../models/formula.model';

// helper
import { extractLinkInfo } from '../../../views/formulaCreate/messagePreview/email/email.helper';

interface LinkElementViewProps {
    element: LinkElement;
}

const LinkElementView: React.FC<React.PropsWithChildren<LinkElementViewProps>> =
    ({ element }) => {
        const linkInfo = useMemo<EmailLinkInfo>(
            () => extractLinkInfo(element?.children?.[0].text),
            [element],
        );

        const handleClick = () => {
            window.open(linkInfo.linkValue, '_blank');
        };

        return (
            <Tooltip title={linkInfo.textValue}>
                <Element onClick={handleClick}>
                    <StyledLink>{linkInfo.textValue}</StyledLink>
                </Element>
            </Tooltip>
        );
    };

const Element = styled.span({
    display: 'inline-block',
    cursor: 'pointer',
    padding: aampeTheme.spacing(0, 0.5),
    borderRadius: aampeTheme.borderRadius.default,
});

const StyledLink = styled.span({
    color: aampeTheme.colors.blue700,
    textDecoration: 'underline',
    '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
    },
});

export default LinkElementView;
